/*global angular */
/*jslint node: true */

'use strict';

var nav = angular.module('nav', []);
nav.directive('navSlot', ['$templateCache', function ($templateCache) {
    return {
        restrict: 'E',
        template: $templateCache.get('slots/nav/nav.html')
    };
}]);
